<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          quartzTaskNo：{{
            formData.quartzTaskNo ? formData.quartzTaskNo : 'New'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.quartzTaskStatus === 'Y'
              ? 'success'
              : formData.quartzTaskStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_quartzTaskStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('sys_quartz_task_quartzTaskType') || '任务类型'"
          >
            <br />
            <el-radio-group v-model="formData.quartzTaskType">
              <el-radio label="A">
                {{ $l('sys_quartz_task_quartzTaskType_A') || 'MQ异步任务' }}
              </el-radio>
              <el-radio label="B">
                {{ $l('sys_quartz_task_quartzTaskType_B') || '同步接口任务' }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('sys_quartz_task_quartzTaskDesc') || '任务说明'"
            prop="quartzTaskDesc"
          >
            <el-input
              v-model.trim="formData.quartzTaskDesc"
              clearable
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('sys_quartz_task_quartzTaskParam') || '任务执行地址'"
            prop="quartzTaskParam"
          >
            <el-input
              v-model.trim="formData.quartzTaskParam"
              clearable
              size="small"
              maxlength="200"
              show-word-limit
              type="text"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('sys_quartz_task_quartzTaskApiTimeOut') ||
                '同步接口请求超时时间'
            "
          >
            <br />
            <el-input-number
              v-model="formData.quartzTaskApiTimeOut"
              clearable
              size="small"
              :min="0"
              controls-position="right"
              :precision="0"
              :step="1"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('sys_quartz_task_quartzTaskExecCron') || 'Corn表达式'"
            prop="quartzTaskExecCron"
          >
            <el-popover v-model="cronPopover">
              <cron
                @change="onChangeCron"
                @close="() => (cronPopover = false)"
              ></cron>
              <el-input
                slot="reference"
                @click="() => (cronPopover = true)"
                v-model="formData.quartzTaskExecCron"
                size="small"
                maxlength="50"
                show-word-limit
                type="text"
                clearable
              ></el-input>
            </el-popover>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('sys_quartz_task_bizParam') || '业务执行参数JSON格式'"
          >
            <el-input
              type="textarea"
              v-model.trim="formData.bizParam"
              clearable
              size="small"
              :rows="4"
              maxlength="500"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <LogTable :quartzTaskCode="quartzTaskCode" v-if="quartzTaskCode" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import LogTable from '../log-table'
import { cron } from 'vue-cron'
export default {
  components: { LogTable, cron },
  mixins: [EditLoading],
  props: {
    quartzTaskCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      cronPopover: false,

      formData: {
        quartzTaskType: 'B',
        quartzTaskExecCron: '',
      },
      rules: {
        quartzTaskDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        quartzTaskParam: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        quartzTaskExecCron: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.quartzTaskCode) return
      this.$api
        .sysQuartzTaskDetailApi({
          quartzTaskCode: this.quartzTaskCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result)
        return this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )

      this.loadingOpen()

      let requestApi
      if (!this.quartzTaskCode) {
        requestApi = this.$api.sysQuartzTaskSaveApi(this.formData)
      } else {
        requestApi = this.$api.sysQuartzTaskUpdateApi(this.formData)
      }

      requestApi
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.quartzTaskCode) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },

    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    onChangeCron(val) {
      this.formData.quartzTaskExecCron = val
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
